import { Injectable } from '@angular/core';
import { HttpRequestDecorator } from 'app/core/triggerbee/http.request.decorator';
import { TriggerbeeApi } from 'app/core/triggerbee/triggerbee-api.enum';
import { BehaviorSubject, Observable } from 'rxjs';
import { CouponModel } from './coupons.models';

@Injectable({
  providedIn: 'root',
})
export class CouponsService {
  public currentCampaignCouponSetBS = new BehaviorSubject<CouponModel>(undefined);

  constructor(private http: HttpRequestDecorator) {}

  public getCoupons(customerId: string): Observable<CouponModel[]> {
    const baseurl = this.http.getBaseUrl(TriggerbeeApi.Gateway);
    return this.http.get(`${baseurl}/coupons/${customerId}/sets`);
  }
  public getCoupon(customerId: string, couponSetId: string): Observable<CouponModel> {
    const baseurl = this.http.getBaseUrl(TriggerbeeApi.Gateway);
    return this.http.get(`${baseurl}/coupons/${customerId}/sets/${couponSetId}`);
  }
  public getCampaignsConnectedToCoupon(customerId: string, couponSetId: string): Observable<CouponModel> {
    const baseurl = this.http.getBaseUrl(TriggerbeeApi.Gateway);
    return this.http.get(`${baseurl}/coupons/${customerId}/sets/${couponSetId}/campaigns`);
  }
  public deleteCoupons(customerId: string, couponSetId: string): Observable<CouponModel[]> {
    const baseurl = this.http.getBaseUrl(TriggerbeeApi.Gateway);
    return this.http.delete(`${baseurl}/coupons/${customerId}/sets/${couponSetId}`);
  }
  public createCoupons(customerId: string, data: CouponModel): Observable<CouponModel[]> {
    const baseurl = this.http.getBaseUrl(TriggerbeeApi.Gateway);
    return this.http.post(`${baseurl}/coupons/${customerId}/sets`, data);
  }
  public createCouponsWithFile(customerId: string, file: FormData): Observable<CouponModel[]> {
    const baseurl = this.http.getBaseUrl(TriggerbeeApi.Gateway);
    return this.http.upload(`${baseurl}/coupons/${customerId}/sets/upload-file`, file);
  }
  public editCouponsWithFile(customerId: string, couponSetId: string, file: FormData): Observable<CouponModel[]> {
    const baseurl = this.http.getBaseUrl(TriggerbeeApi.Gateway);
    return this.http.uploadPut(`${baseurl}/coupons/${customerId}/sets/${couponSetId}/upload-file`, file);
  }
  public editCoupons(customerId: string, couponSetId: string, data: CouponModel): Observable<CouponModel[]> {
    const baseurl = this.http.getBaseUrl(TriggerbeeApi.Gateway);
    return this.http.put(`${baseurl}/coupons/${customerId}/sets/${couponSetId}`, data);
  }
}
